import React from 'react';
import {Button} from "@mui/material";
import {FormattedMessage} from "react-intl";
import ClearIcon from '@mui/icons-material/Clear';

type ClearButtonProps = {
    onClick: () => void;
    color?: string;
};

const ClearButton: React.FC<ClearButtonProps> = (props) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        props.onClick();
    }

    return (
        <Button
            variant="outlined"
            size="small"
            // @ts-ignore
            color={props.color || "secondary"}
            startIcon={<ClearIcon/>}
            onClick={(e) => handleClick(e)}>
            <FormattedMessage id={'COMMON_CLEAR'}/>
        </Button>
    );
};
export default ClearButton;
